export default function Writing() {
  return (
    <main>
<section className="sec">
    <div className="container">
      <p className="eyebrow">Writing</p>
      <h2 className="title">I write about <em>the work</em></h2>
      <p className="sub" style={{marginBottom: '2.4rem'}}>First place at the Zaycodes WriteTech Bootcamp, and I've kept at it since. Seven articles on Medium — mostly React engineering, because the things that trip people up are worth writing down.</p>

      <div className="posts" style={{marginBottom: '2.2rem'}}>
        <a className="post" href="https://medium.com/@johnsonzagazor06/how-i-designed-100-website-templates-at-smartbloksai-89fb01eef084" target="_blank" rel="noopener noreferrer">
          <div className="meta">Design systems</div>
          <h3>How I Designed 100+ Website Templates at SmartbloksAI</h3>
          <span className="read">Read on Medium →</span>
        </a>
        <a className="post" href="https://medium.com/@johnsonzagazor06/from-student-to-head-of-design-my-altschool-africa-journey-471227ff26a3" target="_blank" rel="noopener noreferrer">
          <div className="meta">Career</div>
          <h3>From Student to Head of Design: My AltSchool Africa Journey</h3>
          <span className="read">Read on Medium →</span>
        </a>
      </div>

      <p className="eyebrow">The React series</p>
      <div className="posts">
        <a className="post" href="https://medium.com/@johnsonzagazor06/react-rendering-explained-how-react-decides-what-to-re-render-4792ad993ffb" target="_blank" rel="noopener noreferrer">
          <div className="meta">React · Rendering</div>
          <h3>React Rendering Explained: How React Decides What to Re-render</h3>
          <span className="read">Read on Medium →</span>
        </a>
        <a className="post" href="https://medium.com/@johnsonzagazor06/optimising-react-performance-practical-techniques-for-faster-smoother-apps-fd575c782a70" target="_blank" rel="noopener noreferrer">
          <div className="meta">React · Performance</div>
          <h3>Optimising React Performance: Practical Techniques for Faster, Smoother Apps</h3>
          <span className="read">Read on Medium →</span>
        </a>
        <a className="post" href="https://medium.com/@johnsonzagazor06/mastering-api-integrations-in-react-a-step-by-step-tutorial-0f0db72e8ee2" target="_blank" rel="noopener noreferrer">
          <div className="meta">React · APIs</div>
          <h3>Mastering API Integrations in React: A Step-by-Step Tutorial</h3>
          <span className="read">Read on Medium →</span>
        </a>
        <a className="post" href="https://medium.com/@johnsonzagazor06/integrating-the-context-api-in-react-b880d558712d" target="_blank" rel="noopener noreferrer">
          <div className="meta">React · State</div>
          <h3>Integrating the Context API in React</h3>
          <span className="read">Read on Medium →</span>
        </a>
        <a className="post" href="https://medium.com/@johnsonzagazor06/understanding-the-basics-of-map-and-arrays-in-react-d380f37764bc" target="_blank" rel="noopener noreferrer">
          <div className="meta">React · Fundamentals</div>
          <h3>Understanding the Basics of Map and Arrays in React</h3>
          <span className="read">Read on Medium →</span>
        </a>
      </div>
      <a className="go" href="https://medium.com/@johnsonzagazor06" target="_blank" rel="noopener noreferrer">All articles on Medium →</a>
    </div>
  </section>
    </main>
  );
}
